export const SET_ONBOARDING = 'SET_ONBOARDING';
export const NEXT_STEP = 'NEXT_STEP';
export const END_ONBOARDING = 'END_ONBOARDING';
export const RESET_STEPS = 'RESET_STEPS';
